import { render, staticRenderFns } from "./article-window.vue?vue&type=template&id=27772f4b&"
import script from "./article-window.vue?vue&type=script&lang=js&"
export * from "./article-window.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports